import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Container, Typography } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { SEO } from "../components/SEO";

const NotFound: React.FC = () => (
  <>
    <SEO title="Page Not Found" description="The page you are looking for does not exist." noindex />
    <Container maxWidth="md" sx={{ py: { xs: 10, md: 16 }, textAlign: "center" }}>
      <Typography
        variant="h1"
        sx={{ fontSize: { xs: "5rem", md: "7rem" }, fontWeight: 800, color: "secondary.main" }}
      >
        404
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 700 }}>
        Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 480, mx: "auto" }}>
        The page you are looking for doesn't exist or may have moved. Explore our
        products or head back to the homepage.
      </Typography>
      <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
        <Button component={RouterLink} to="/" variant="contained" color="secondary" size="large" startIcon={<HomeIcon />}>
          Go Home
        </Button>
        <Button component={RouterLink} to="/products" variant="outlined" size="large" startIcon={<StorefrontIcon />}>
          Browse Products
        </Button>
      </Box>
    </Container>
  </>
);

export default NotFound;
